import { resolveApiOrigin } from '@vipso/shared';

const EXT_MIME: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  heic: 'image/heic',
  heif: 'image/heif',
  avif: 'image/avif',
  bmp: 'image/bmp',
};

/** Browsers often leave File.type empty; FormData then sends application/octet-stream. */
function normalizeImageFile(file: File): File {
  if (file.type.startsWith('image/')) return file;
  const ext = file.name.split('.').pop()?.toLowerCase();
  const mime = ext ? EXT_MIME[ext] : undefined;
  if (!mime) return file;
  return new File([file], file.name || `upload.${ext}`, { type: mime });
}

export async function uploadFile(
  file: File,
  accessToken: string,
): Promise<{ id: string; url: string }> {
  const normalized = normalizeImageFile(file);
  const formData = new FormData();
  formData.append('file', normalized, normalized.name);

  const apiUrl = resolveApiOrigin();
  if (!apiUrl) {
    throw new Error('VITE_API_URL is not set');
  }

  const res = await fetch(`${apiUrl}/api/files/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });

  const body = (await res.json().catch(() => ({}))) as { id?: string; url?: string; error?: string };
  if (!res.ok) {
    throw new Error(body.error || 'Upload failed');
  }
  if (!body.id || !body.url) {
    throw new Error('Invalid upload response');
  }
  return { id: body.id, url: body.url };
}
